import styled from "@emotion/styled";
import { useTranslations } from "ilenia";
import React from "react";

import * as Icons from "../../icons";
import styles from "../../styles/sideNav.module.scss";
import * as Types from "../../types";
import { keyboardEnterOrSpaceClick } from "../../utils";

const StyledBurgerMenuContainer = styled.div(() => ({
  borderRadius: "100%",
  marginLeft: 12,
  ["span"]: {
    marginLeft: "0px !important",
  },
  ":hover": {
    ["span > svg"]: {
      fill: "#205cd4 !important",
    },
  },
  ":focus": {
    ["span > svg"]: {
      borderRadius: "100% ",
    },
  },
}));

export const BurgerMenu: React.FC<Types.BurgerMenu> = ({
  expandMenuOnMobile,
  useSimplifiedLayout,
  setShowSubMenu,
  showSubMenu,
}) => {
  const [translations] = useTranslations();

  if (useSimplifiedLayout) {
    return null;
  }

  return (
    <StyledBurgerMenuContainer
      onClick={() => {
        expandMenuOnMobile();
        setShowSubMenu(true);
      }}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        keyboardEnterOrSpaceClick(event, () => {
          expandMenuOnMobile();
          setShowSubMenu(true);
        });
      }}
      aria-label={translations["ButtonAriaLabels.toggleMenu"]}
      aria-expanded={showSubMenu}
      aria-controls="sidebar"
    >
      <span className={styles.sidebarBurgerMenu} data-testid="appshell_burger">
        <Icons.Burger />
      </span>
    </StyledBurgerMenuContainer>
  );
};
